export function setReglas(state, reglas) {
    state.reglas = reglas;
}


export function setReglaSelec(state, regla) {
    state.reglaSelec = regla;
}

export function actDeleteListReglas(state, id) {
    if (id != null) {
        const index = state.reglas.findIndex(r => r.id === id)
        if (index != -1) {
            state.reglas.splice(index, 1)
        }
    }
}


export function actListReglas(state, regla) {
    if (regla !== null) {
        const index = state.reglas.findIndex(r => r.id === regla.id)
        if (index != -1) {
            state.reglas[index].dia_desde = regla.dia_desde;  
            state.reglas[index].dia_hasta = regla.dia_hasta;  
            state.reglas[index].fecha_desde = regla.fecha_desde;  
            state.reglas[index].fecha_hasta = regla.fecha_hasta;  
            state.reglas[index].nombre = regla.nombre;
            state.reglas[index].proveedor = regla.proveedor;
            state.reglas[index].proveedor_id = regla.proveedor_id;  
            state.reglas[index].tarifas = regla.tarifas;  
        }
    }
  
}

